import { IconButton, Close16, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import { IOffer } from '../../offer';
import * as styles from './ChatPopup.css';
import { getAgentName } from './getAgentName';

interface IChatPopupProps {
  offer: IOffer;
  onClose(): void;
  dates: { checkin: string; checkout: string } | null;
}

export const ChatPopup: React.VFC<IChatPopupProps> = ({ offer, onClose, dates }) => {
  const { user, id, dealType, offerType } = offer;

  const [isLoading, setIsLoading] = React.useState(true);

  const companionName = getAgentName(offer);

  const onLoad = () => setIsLoading(false);

  /* istanbul ignore next */
  const src =
    `/dialogs/?hostType=frame&offerId=${id}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${companionName ? '&companionName=' + encodeURIComponent(companionName) : ''}` +
    `${user?.cianUserId ? '&companionId=' + encodeURIComponent(user?.cianUserId) : ''}` +
    '&pageType=Listing' +
    `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
    `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}`;

  return (
    <div className={styles['container']}>
      <span className={styles['close']}>
        <IconButton icon={<Close16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
